// removed by extract-text-webpack-plugin
module.exports = {"muiThemePrimary":"#364c59","settings":"AuditTemplateSettings__settings__1tT-U","table":"AuditTemplateSettings__table__1qjY9","row":"AuditTemplateSettings__row__eFK_Y","column":"AuditTemplateSettings__column__a_jyQ","slider":"AuditTemplateSettings__slider__3ePRA","autosuggestColumn":"AuditTemplateSettings__autosuggestColumn__1b3xR"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateDetailView/AuditTemplateSettings/AuditTemplateSettings.scss
// module id = 1758
// module chunks = 0